<main class="container my-5 pt-5">
    <div class="container-fluid main-content">
        <div class="custom-card">
            <div class="card-body d-flex row justify-content-center">
                <h2 class="custom-card-title text-center">Who We Are</h2><br/><br/>
                  <h5 class="mt-4"><b>Green and Healthy Schools Program History, Vision and Mission</b> </h5>
              <div>
                <a href="https://gwinnettcb.org">
                    <img src="./assets/GreenAndHealthySchools_Logo.png" alt="GGC Green Logo" class="float-start img-fluid">
                  </a>
                <p class="d-inline">
                  <i>What:</i> A joint effort and partnership between Gwinnett Clean & Beautiful (GC&B) and Gwinnett County Public Schools (GCPS) <br>
                  <i>Legacy:</i> A 30+ year partnership with a focus on developing community partnerships to augment GCPS K-12 Environmental &
                  Sustainability Education. The Green & Healthy School Program has a strong history and track record in working with its schools on
                  implementing a systematic program to engage educators and students throughout the county’s 140+ school, over 22,000 educators and staff,
                  and 180,000 plus students. <br>
                  <i>How:</i> Engages students in hands-on, real-world, problem and project-based learning fostering interest in Science and STEM onramps
                  and careers though strengthens the connection to community and professional networks and Community service and civic engagement opportunities.
                </p>
                <br>
                <i>Key values:</i>
                <ul>
                  <li class="bullet">Increase the Capacity of GCPS Educators and Administrators through Structured Professional Development Learning, Collaboration, and Networking Opportunities. </li>
                  <li class="bullet">Sharing best practices and scaling the program across the GCPS district and across the state. </li>
                </ul>
              </div>
              <h5 class="fw-bold mb-3 mt-4"><b>Gwinnett Clean and Beautiful Services, Inc. (GC&B): </b></h5>

              <div class="text-center mb-1">
                <a href="https://gwinnettcb.org"><img src="./assets/GCB-Logo.png" alt="GCB Logo" class="img-fluid" id="gcb"></a>
              </div>
              <div>
                <p class="d-inline mt-4">
                  GC&B’s mission is to Connect People & Resources for a Sustainable Gwinnett, with our guiding principles of championing and supporting environmental
                    education curricula and programs with primary, secondary and higher educational partners as a key to encouraging positive behaviors and daily actions toward a healthier
                    environment and more livable community, and does so through building and sustaining broad based community partnerships and alliances dedicated to finding long-term solutions
                    to environmental and quality of life issues through individual action.  The organization is guided by a Citizens Advisory Board that is composed of local leaders from businesses,
                    government, education and civic organizations, representing all sectors of the Gwinnett County community and provides strategic direction to ensure it remains community-driven and mission-focused.
                  <br/>
                 GC&B is an award-winning, nationally recognized 501(c)(3) charitable organization and local affiliate of Keep Georgia Beautiful Foundation and Keep America Beautiful,
                    the nation’s iconic community improvement nonprofit organization, that inspires and educates people to take action every day to improve their community environment, state and local affiliates,
                    millions of volunteers, and the support of corporate partners, social and civic service organizations, academia, municipalities and government officials.
               </div>
              </div>

          <div class="ratio ratio-21x9">
            <iframe src="https://www.youtube.com/embed/?listType=playlist&list=PLqw7EHriJ-bdRfDNREdh0v-QCC27njQTX" title="GCB Youtube Playlist" style="max-width: 100%;height: 100%;" allowfullscreen></iframe>
          </div>

          <br/>

          <h2 class="custom-card-title text-center">Our Team</h2>
          <div class="row text-center">
            <div *ngFor="let member of teamMembers" class="col-md-4 mb-3">
              <h5 class="fw-bold mb-0 d-flex align-items-center justify-content-center gap-2">
                {{ member.name }}
                <ng-container *ngIf="member.website">
                  <a [href]="member.website" target="_blank">
                    <img *ngIf="member.website == 'https://gwinnettcb.org' && member.name == 'Schelly Marlatt'" src="./assets/GCB-Logo.png" alt="GCB Logo" style="max-height: 40px;">
                    <img *ngIf="member.website == 'https://gwinnettcb.org'&& member.name == 'Brenda McDaniel'" src="./assets/ghs.png" alt="GCB Logo" style="max-height: 40px;">
                    <img *ngIf="member.website == 'https://www.gcpsk12.org'" src="./assets/public-school-logo.png" alt="GCB Logo" style="max-height: 40px;">
                  </a>
                </ng-container>
              </h5>
              <h6 class="fw-normal">{{ member.role }}</h6>
              <p class="mb-0">
                <a [href]="'mailto:' + member.email">{{ member.email }}</a>
              </p>
            </div>
          </div>
        </div>
    </div>
</main>
